import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./staffdashboard.css";
import { useTranslation } from 'react-i18next';
import hospital from "../../assets/ac/hospital.jpg"
import banner from "../../assets/ac/banner.png"
import revenue from "../../assets/ac/revenue.png"
// import VerifyOTP from "./../ConfigDashboard/VerifyOTP";
// Placeholder icon for Service Catalogue
import serviceCatalogueIcon from "../../assets/images/icons/service-catalogue.png";

function Dashboard() {
  const { t } = useTranslation();

  return (
    <>
      <div className="home" style={{ minHeight: "71vh" }} >
        <div className="home-container">
          <div className="home-tiles">
            <Link to="/hospitallist" style={{ textDecoration: "none" }}>
              <img className="home-icon" width="66" height="66" src={hospital} alt="" />
            </Link>
            <h4 className="each-title">{t('dashboardMenu.vendors')} </h4>
          </div>

          {/* Service Catalogue Tile */}
          <div className="home-tiles">
            <Link to="/servicecatalogue" style={{ textDecoration: "none" }}>
              <img className="home-icon" width="66" height="66" src={serviceCatalogueIcon} alt="Service Catalogue" />
            </Link>
            <h4 className="each-title">{t('dashboardMenu.catalogues')}</h4>
          </div>
          <div className="home-tiles">
            <Link to="/master-banners" style={{ textDecoration: "none" }}>
              <img className="home-icon" width="66" height="66" src={banner} alt="Service Catalogue" />
            </Link>
            <h4 className="each-title">{t('dashboardMenu.banners')}</h4>
          </div>
          <div className="home-tiles">
            <Link to="/liability" style={{ textDecoration: "none" }}>
              <svg className="home-icon" width="66" height="66" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91 2.58.6 3.91 1.69 3.91 3.71 0 1.78-1.37 2.83-3.12 3.16z" fill="#4DA7A7" />
              </svg>
            </Link>
            <h4 className="each-title">{t('dashboardMenu.liabilities')}</h4>
          </div>
          <div className="home-tiles">
            <Link to="/revenue" style={{ textDecoration: "none" }}>
              <img className="home-icon" width="66" height="66" src={revenue} alt="Revenue" />
            </Link>
            <h4 className="each-title">{t('dashboardMenu.revenue')}</h4>
          </div>
        </div>
      </div >
    </>
  );
}
export default Dashboard;
